<template>
  <modal @close="onClose">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-half">
          <div class="box">
            <h1 class="title">Login</h1>
            <p class="subtitle help is-7">
              You are being shown this form because your session has expired and you
              need to relogin to your account.
            </p>

            <form-wizard
              :fields="['email', 'password']"
              :metadata="LoginMetaData"
              @submit="onLogin"
            ></form-wizard>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Library from '@/library'

export default {
  name: 'LoginModal',

  methods: {
    onClose () {
      this.$store.commit('auth/setShowLoginModal', false)
      this.$store.commit('auth/setToken', null)
      this.$router.push({ name: 'Login' })
    },

    async onLogin (credentials) {
      const loader = this.$loading.open()

      try {
        this.$store.commit('auth/setToken', null)
        await this.$store.dispatch('auth/login', {
          userName: credentials.email,
          password: credentials.password
        })

        this.$store.commit('auth/setShowLoginModal', false)
      } catch (e) {
        console.log(e)
        if (e.response.status === 401) {
          this.$handleError('Check your credentials and try again.')
        } else {
          this.$handleError('There was a server error while logging into your account.', e.response.data)
        }
      } finally {
        loader.close()
      }
    }
  },

  computed: {
    LoginMetaData () {
      return {
        entityName: 'Login',
        properties: [
          {
            propertyName: 'email',
            inputType: 'Email',
            defaultValue: null,
            isCollection: false,
            typeName: 'String',
            isReadOnly: false,
            isForeignKey: false,
            isPrimaryKey: false,
            isDependentType: false,
            properties: null,
            options: {
              allowsNulls: false,
              isRequired: true,
              maximum: 255,
              minimum: null,
              stepSize: null,
              possibleValues: null
            }
          },
          {
            propertyName: 'password',
            inputType: 'Password',
            defaultValue: null,
            isCollection: false,
            typeName: 'String',
            isReadOnly: false,
            isForeignKey: false,
            isPrimaryKey: false,
            isDependentType: false,
            properties: null,
            options: {
              allowsNulls: false,
              isRequired: true,
              maximum: 255,
              minimum: 8,
              stepSize: null,
              possibleValues: null
            }
          }
        ]
      }
    }
  },

  components: {
    Modal: Library.Components.Modal,
    FormWizard: Library.Components.FormWizard
  }
}
</script>
